import { useMutation, useQueryCache } from "react-query";
import network from "../../../selectors/network";
import { useToasts } from "react-toast-notifications";
import { deleteReportById } from "../../../queries/legacyReports/deleteReportById";
import { useSelector } from "react-redux";

export function useReportsDeleteMutation(reportId: Number) {
  const queryCache = useQueryCache();
  const networkHeaders = useSelector(network.defaultHeaders);
  const toasts = useToasts();
  const [deleteReport, deleteReportState] = useMutation(deleteReportById(networkHeaders, Number(reportId)), {
    onSuccess: () => {
      toasts.addToast("Report deleted successfully", { appearance: "success", autoDismiss: true });
      queryCache.invalidateQueries("reports.list");
    },
    onError: () => {
      toasts.addToast("Failed to delete the report", { appearance: "error", autoDismiss: true });
    },
  });

  return {
    isLoading: deleteReportState.isLoading,
    deleteReport: () => deleteReport(),
  };
}
